<script lang="ts">
	export let avatar_url;
	export let alt = '...';
</script>

{#if avatar_url}
	<img
		loading="lazy"
		decoding="async"
		class="mt-1 rounded-full object-cover w-8 h-8 border-1 border-bloomPurpleNormal"
		width="32"
		height="32"
		src={avatar_url}
		{alt}
	/>
{:else}
	<div class="mt-1 w-8 h-8 rounded-full bg-cosmicPurple600 opacity-60"></div>
{/if}
